import { IFCWithChildren } from '~/common/interfaces/IFCWithChildren';
import { IAboveComponentDefaultProps } from '~/common/interfaces/IAboveComponentDefaultProps';
import { AboveComponentBoxPositionTypes } from '~/common/@types/AboveComponentBoxPositionTypes';

import { Arrow, BoxWrapper } from './styles';

interface IAboveBoxProps extends IAboveComponentDefaultProps {
  visible: boolean;
  position: AboveComponentBoxPositionTypes;
  withoutPadding?: boolean;
  popover?: boolean;
  background: 'neutral.50' | 'neutral.950';
  id: string;
}
export const AboveBox: IFCWithChildren<IAboveBoxProps> = ({
  children,
  visible,
  position,
  background,
  arrowPosition,
  withoutPadding,
  popover,
  id,
}) => {
  return (
    <BoxWrapper
      id={id}
      $visible={visible}
      $position={position}
      $withoutPadding={withoutPadding}
      backgroundColor={background}
      $popover={popover}
    >
      {children}
      <Arrow
        $visible={visible}
        background={background}
        $side={arrowPosition}
        $position={
          position === 'bottom'
            ? 'top'
            : position === 'top'
            ? 'bottom'
            : position
        }
      />
    </BoxWrapper>
  );
};
